import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  // 3: {
  //   unit: "Unit Starter",
  //   id: "FP8-WB-demo-2023-US-P4-E2",
  //   audio: "Audios/bt_fpt_ai/danh_tu_bt3.mp3",
  //   video: "",
  //   autoPlay: true,
  //   // recorder: true,
  //   exerciseKey: "/img/FriendsPlus/Page12/Key/E3answerKey.png",
  //   component: Circle_Write,

  //   titleQuestion: [
  //     {
  //       num: "3",
  //       title: `

  // 	`,
  //       color: "rgb(3, 103, 181)",
  //     },
  //   ],
  //   textareaStyle: { width: 300, paddingTop: "5px" },
  //   question: {
  //     Write: {
  //       inputStyle: { width: 750, padding: 20 },
  //       answers: [
  //         "người, anh hùng, tuổi, tên, nơi, quê, thôn, xã, huyện, tỉnh, nhiệm vụ, cán bộ",
  //         "Kim Đồng, Việt Nam, Nông Văn Dền, Nà Mạ, Trường Hà, Hà Quảng, Cao Bằng",
  //       ],
  //       initialValue: [],
  //     },
  //     Circle: {
  //       initialWordStyle: {},
  //       // initialWordSt<yle: { fontWeight: 'bold', border: 'none',  borderColor: 'transparent' },
  //       selectWordStyle: { padding: "0", borderBottom: "2px solid black" },
  //       limitSelect: 27,
  //       listWords: [
  //         `&emsp; Kim_Đồng là người anh_hùng nhỏ tuổi của Việt_Nam. Anh tên thật là Nông_Văn_Dèn (Có nơi viết là Nông_Văn_Dền), quê ở thôn Nà_Mạ, xã Trường_Hà, huyện Hà_Quảng, tỉnh Cao_Bằng.
  //         Trong lúc làm nhiệm_vụ liên_lạc cho cán_bộ cách_mạng, anh đã anh_dũng hi_sinh. Khi đó anh vừa tròn 14 tuổi.
  //         `,
  //       ],
  //       answers: [
  //         [
  //           "0-2",
  //           "0-6",
  //           "0-8",
  //           "0-12",
  //           "0-16",
  //           "0-20",
  //           "0-26",
  //           "0-36",
  //           "0-30",
  //           "0-38",
  //           "0-42",
  //           "0-44",
  //           "0-48",
  //           "0-52",
  //           "0-56",
  //           "0-54",
  //           "0-46",
  //           "0-50",
  //           "0-84",
  //           "0-90",
  //           "0-114",
  //         ],
  //       ],

  //       initialValue: [],
  //     },
  //     Layout: `
  //   <div style='width:24cm;margin-bottom:20px'>
  //     <b>a.</b>&ensp;Gạch dưới các danh từ trong đoạn văn.<br>
  //     <input id='0' type='Circle'/>
  //   </div>
  //     <b>b</b>&ensp;Viết những danh từ tìm được trong đoạn văn ở bài tập a vào nhóm thích hợp.
  // 		<div>
  //       <div style='text-align:center'>

  //       </div>
  //     </div>

  //     <div style='display:flex;margin-top:20px;'>
  //       <div style='margin:0px 100px'>
  //         <div style='margin-left:22px; background:rgb(3 103 181); border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:4px 10px;width:7cm;text-align:center '>
  //           Danh từ chung
  //         </div>
  //         <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:4px 0px;width:82mm;'>
  //           <textarea id='0' rows='4'></textarea>
  //         </div>
  //       </div>
  //       <div >
  //         <div style='margin-left:22px;background:rgb(3 103 181);border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:4px 10px;width:7cm;text-align:center '>
  //           Danh từ riêng
  //         </div>
  //         <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:4px 0px;width:82mm;'>
  //           <textarea id='1' rows='4'></textarea>
  //         </div>
  //       </div>
  //     </div>

  //        `,
  //   },
  // },
  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E2",
    audio: "Audios/bt_fpt_ai/danh_tu_bt3.mp3",
    video: "",
    autoPlay: true,
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page12/Key/E3answerKey.png",
    component: Circle_Write,

    titleQuestion: [
      {
        num: "",
        title: `
		
		`,
        color: "rgb(3, 103, 181)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "hướng dẫn",
        description: `<span>
        a. Em hãy kích chuột dưới mỗi danh từ tìm được trong đoạn văn.<br>
        b. Em đưa các danh từ tìm được vào từng ô phù hợp bằng cách gõ chữ vào chỗ chấm.<br>         
        <div><video src="Audios/bt_fpt_ai/guide/p13_e3.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
        
    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>
        
    //     `,
    //   },
    // ],
    textareaStyle: { width: 300, paddingTop: "5px" },
    question: {
      Write: {
        inputStyle: { width: 750, padding: 20 },
        answers: [
          "người, anh hùng, tuổi, tên, nơi, quê, thôn, xã, huyện, tỉnh, nhiệm vụ, cán bộ",
          "Kim Đồng, Việt Nam, Nông Văn Dèn, Nông Văn Dền, Nà Mạ, Trường Hà, Hà Quảng, Cao Bằng",
        ],

        initialValue: [],
      },
      Circle: {
        initialWordStyle: {},
        // initialWordSt<yle: { fontWeight: 'bold', border: 'none',  borderColor: 'transparent' },
        selectWordStyle: { padding: "0", borderBottom: "2px solid black" },
        limitSelect: 21,
        listWords: [
          `&emsp; Kim_Đồng là người anh_hùng nhỏ tuổi của Việt_Nam. Anh tên thật là Nông_Văn_Dèn (Có nơi viết là Nông_Văn_Dền), quê ở thôn Nà_Mạ, xã Trường_Hà, huyện Hà_Quảng, tỉnh Cao_Bằng.
          Trong lúc làm nhiệm_vụ liên_lạc cho cán_bộ cách_mạng, anh đã anh_dũng hi_sinh. Khi đó anh vừa tròn 14 tuổi.
          `,
        ],
        answers: [
          '0-114', '0-38', '0-2', '0-8', '0-6', '0-12', '0-16', '0-20', '0-26', '0-30', '0-36', '0-42', '0-44', '0-46', '0-48', '0-50', '0-52', '0-54', '0-56', '0-84', '0-90'
        ],

        initialValue: [],
      },
      Layout: `
    <div style='display:flex'>                            
        <b style='color:rgb(3, 103, 181);font-size:26px'>                            
           3
        </b>
      <div style='margin-left:10px'>
        <div style='width:24cm;margin-bottom:20px'>
          <b>a.</b>&ensp;Gạch dưới các danh từ trong đoạn văn.<br>
          <input id='0' type='Circle'/>
        </div>
          <b>b</b>&ensp;Viết những danh từ tìm được trong đoạn văn ở bài tập a vào nhóm thích hợp.
		    	<div>
            <div style='text-align:center'>


            </div>
          </div>

          <div style='display:flex;margin-top:20px;'>
            <div style='margin:0px 100px'>
              <div style='margin-left:22px;background:rgb(3 103 181);border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:4px 10px;width:7cm;text-align:center '>
                Danh từ chung
              </div>
              <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:4px 0px;width:82mm;'>
                <textarea id='0' rows='4'></textarea>
              </div>
            </div>
            <div >
              <div style='margin-left:22px;background:rgb(3 103 181);border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:4px 10px;width:7cm;text-align:center '>
                Danh từ riêng
              </div>
              <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:4px 0px;width:82mm;'>
                <textarea id='1' rows='4'></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

        
         `,
    },
  },
  4: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E4",
    audio: "Audios/bt_fpt_ai/danh_tu_bt4.mp3",
    video: "",
    autoPlay: true,
    isTuLuan:true,
    // recorder: true,
    exerciseKey: "img/FriendsPlus/Page12/Key/E4answerKey.png",
    component: T6,
    textareaStyle: { width: 300, paddingTop: "5px" },
    // hideBtnFooter:true,
    // isEssay: true,
    questionImage: [],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "hướng dẫn",
        description: `<span>
        Em tìm danh từ theo yêu cầu và gõ chữ vào dòng kẻ ở từng ô cho phù hợp.      
        <div><video src="Audios/bt_fpt_ai/guide/p13_e4.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
        
    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>
        
    //     `,
    //   },
    // ],
    titleQuestion: [
      {
        num: "4.",
        title: `
       Viết 1 danh từ phù hợp với mỗi nhóm dưới đây:
				`,
        color: "rgb(3, 103, 181)",
        // star:3
      },
    ],
    questions: [
      {
        title: `
      <div style='display:flex;margin-top:20px'>
        <div>
          <div style='margin-left:22px; background:rgb(3 103 181); height: 3cm; border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:16px 4px 10px;width:7cm;text-align:center '>
            Danh từ chung chỉ 1 dụng cụ học tập
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:16px 4px 0px;width:82mm;'>
            <textarea id='0' rows='3'></textarea>
          </div>
        </div>
        <div style='margin:0 20px'>
          <div style='margin-left:22px; background:rgb(3 103 181); height: 3cm; border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:16px 4px 10px;width:7cm;text-align:center '>
            Danh từ riêng gọi tên 1 người bạn
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:16px 4px 0px;width:82mm;'>
            <textarea id='1' rows='3'></textarea>
          </div>
        </div>
        <div >
          <div style='margin-left:22px; background:rgb(3 103 181); height: 3cm; border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:16px 4px 10px;width:7cm;text-align:center '>
            Danh từ chung chỉ 1 nghề
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:16px 4px 0px;width:82mm;'>
            <textarea id='2' rows='3'></textarea>
          </div>
        </div>
      </div>

      <div style='display:flex;margin-top:20px'>
        <div>
          <div style='margin-left:15px; background:rgb(3 103 181); height: 3cm; border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:16px 4px 10px;width:75mm;text-align:center '>
            Danh từ riêng gọi tên 1 con đường, con phố
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:16px 4px 0px;width:82mm;'>
            <textarea id='3' rows='3'></textarea>
          </div>
        </div>
        <div style='margin:0 20px'>
          <div style='margin-left:3px; background:rgb(3 103 181); height: 3cm; border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:16px 4px 10px;width:8cm;text-align:center '>
            Danh từ chung chỉ 1 đồ dùng trong gia đình
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:16px 4px 0px;width:82mm;'>
            <textarea id='4' rows='3'></textarea>
          </div>
        </div>
        <div >
          <div style='margin-left:22px; background:rgb(3 103 181); height: 3cm; border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:16px 4px 10px;width:7cm;text-align:center '>
            Danh từ riêng gọi tên 1 đất nước
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:16px 4px 0px;width:82mm;'>
            <textarea id='5' rows='3'></textarea>
          </div>
        </div>
      </div>
      
        
        `,
        answer: [
          "",
          "",
          "",
          "",
          "",
          "",
          // "thước, bút, cặp sách, sách, vở,…",
          // "Hạnh, Hà, Nam,… Nguyễn Gia Hưng, Vũ Hà Phương,…",
          // "giáo viên, bác sĩ, kĩ sư, y tá,…",
          // "Kim Mã, Nguyễn Chí Thanh",
          // "quạt, bát, đĩa, cháo, nồi,…",
          // "Mỹ, Pháp, Ba Lan, Hàn Quốc,…",
        ],
      },
    ],
  },

  5: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E4",
    audio: "Audios/bt_fpt_ai/danh_tu_bt5.mp3",
    video: "",
    isTuLuan:true,
    autoPlay: true,
    // recorder: true,
    exerciseKey: "img/FriendsPlus/Page12/Key/E5answerKey.png",
    component: T6,
    stylesTextInput: {
      background: "none",
      // borderBottom: "none",
      fontSize: 23,
      height: 30,
      // textTransform: 'uppercase',
      // borderStyle: "dotted",
      textAlign: "left",
    },
    // hideBtnFooter:true,
    // isEssay: true,
    isHiddenCheck: true,
    questionImage: [],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "hướng dẫn",
        description: `<span>
        Em gõ các câu vào chỗ chấm ở mục a, b, c. Sau khi gõ xong các câu, em kích chuột vào danh từ trong câu.
        <div><video src="Audios/bt_fpt_ai/guide/p13_e5.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    
    titleQuestion: [
      {
        num: "5.",
        title: `
       Viết 3 câu, mỗi câu chứa 1 danh từ chung hoặc một danh từ riêng. Gạch dưới các danh từ đó.
				`,
        color: "rgb(3, 103, 181)",
        // star:3
      },
    ],
    questions: [
      {
        title: `
        <div style='line-height: 55px; font-size: 23px'>
        <div>
        <b>a.&ensp;</b><input id='0' width='900px'/><br>
        <b style='margin-left: 30px'>Danh từ chung/riêng trong câu: <input id='1' width='300px'/></b>
        </div>
        <div>
        <b>b.&ensp;</b><input id='2' width='900px'/><br>
        <b style='margin-left: 30px'>Danh từ chung/riêng trong câu: <input id='3' width='300px'/></b>
        </div>
        <div>
        <b>c.&ensp;</b><input id='4' width='900px'/><br>
        <b style='margin-left: 30px'>Danh từ chung/riêng trong câu: <input id='5' width='300px'/></b>
        </div>

        </div>
        `,
        answer: [
          "",
          "",
          "",
          "",
          "",
          "",
          // "Mai rất thích học múa.",
          // "Mai",
          // "Bông hoa tỏa hương thơm ngát.",
          // "Bông hoa",
          // "Bánh kem rất ngọt.",
          // "Bánh kem",
        ],
      },
    ],
  },
};

export default json;
